import { useContext, useState, ComponentProps } from 'react';
import { connect } from 'react-redux';
import { useUnmountPromise } from 'react-use';

import * as actions from '../../../vehicles/store/actions';
import { useComponentDidMount } from '../../hooks';
import { FormContext, SelectInput, MultiSelectInput } from '../forms';

/** Минимальный структурный тип элемента справочника марок (готового интерфейса в vehicles/api нет). */
interface VehicleMakeItem {
  id: string | number,
  title?: string,
}

type VehicleMakerSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>,
  'value' | 'defaultValue' | 'onChange'> & {
  disabled?: boolean,
  onChange?: (event: any) => void,
  showDeleted?: boolean,
  multiSelect?: boolean,
  /** из mapStateToProps */
  makes?: VehicleMakeItem[],
  /** из mapDispatchToProps */
  getVehicleMakes: (showDeleted?: boolean) => Promise<unknown>,
};

const VehicleMakerSelector = (props: VehicleMakerSelectorProps) => {
  const mounted = useUnmountPromise();
  // FormContext создаётся в utils.js без дженерика — приводим к нужной форме (см. SelectInput.tsx)
  const { handleChange } = useContext(FormContext) as { handleChange?: (event: any) => void };
  const {
    disabled,
    makes,
    getVehicleMakes,
    onChange,
    showDeleted = false,
    multiSelect = false,
    name = 'makeId',
    ...rest
  } = props;

  const [loading, setLoading] = useState(false);

  const loadData = (): Promise<unknown> => {
    setLoading(true);

    return getVehicleMakes(showDeleted).finally(() => setLoading(false));
  };

  useComponentDidMount(() => {
    mounted(loadData());
  });

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          name={ name }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ makes }
          dataTitle='title'
          dataValue='id'
          loading={ loading }
          disabled={ disabled }
          // onChange={ (event) => { handleChange(event); if (typeof onChange === 'function') onChange(event); } }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          name={ name }
          data={ makes }
          dataTitle='title'
          dataValue='id'
          loading={ loading }
          disabled={ disabled || loading }
          onChange={ (event) => { handleChange(event);if (typeof onChange === 'function') onChange(event); } }
          sort
        />
      )

  );
};

const mapStateToProps = (state) => {
  return {
    makes: state.vehicles?.makes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVehicleMakes: payload => dispatch(actions.getVehicleMakes(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleMakerSelector);
